import { apiGet } from "../client";
import type { RecentTransactionListResponseApi } from "../models/recentTransaction";

export async function getRecentTransactions(): Promise<RecentTransactionListResponseApi> {
  return apiGet<RecentTransactionListResponseApi>("transactions");
}
